import styled from "styled-components";

export const TLModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TLModalTopSection = styled.form`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const TLModalGrid = styled.div`
  overflow: auto;
  width: 1050px;
`;
